import { render, staticRenderFns } from "./TvDetails.vue?vue&type=template&id=5428c6d4&scoped=true&"
import script from "./TvDetails.vue?vue&type=script&lang=js&"
export * from "./TvDetails.vue?vue&type=script&lang=js&"
import style0 from "./TvDetails.vue?vue&type=style&index=0&id=5428c6d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5428c6d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5428c6d4')) {
      api.createRecord('5428c6d4', component.options)
    } else {
      api.reload('5428c6d4', component.options)
    }
    module.hot.accept("./TvDetails.vue?vue&type=template&id=5428c6d4&scoped=true&", function () {
      api.rerender('5428c6d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TvDetails.vue"
export default component.exports